import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}

ReactDOM.render(<App />, document.getElementById('root'))
unregister()